import { Component } from '@angular/core';
import {
    InsurancePolicyDataService,
    NewModalRef,
    PolicyProductIdEnum,
    PolicyValidityStatusCodeEnum,
    PurchasedProductInterface,
} from 'outshared-lib';
import { Observable } from 'rxjs';

/** @deprecated - insurances functionality is moved to libs/my-zone/insurances */
@Component({
    selector: 'ins-insurance-imic-modal',
    templateUrl: './insurance-imic.modal.html',
    styleUrls: ['./insurance-imic.modal.scss'],
})
export class InsuranceIMICModalComponent {
    public car$: Observable<PurchasedProductInterface[]>;
    public moped$: Observable<PurchasedProductInterface[]>;
    public motorcycle$: Observable<PurchasedProductInterface[]>;
    public caravan$: Observable<PurchasedProductInterface[]>;
    public validityStatusCodeEnum: typeof PolicyValidityStatusCodeEnum;

    constructor(
        private activeModal: NewModalRef<InsuranceIMICModalComponent>,
        private insurancePolicyDataService: InsurancePolicyDataService,
    ) {
        this.car$ = this.insurancePolicyDataService
            .getPurchasedProductsByProductId$(PolicyProductIdEnum.Car);
        this.moped$ = this.insurancePolicyDataService
            .getPurchasedProductsByProductId$(PolicyProductIdEnum.Moped);
        this.motorcycle$ = this.insurancePolicyDataService
            .getPurchasedProductsByProductId$(PolicyProductIdEnum.Motorcycle);
        this.caravan$ = this.insurancePolicyDataService
            .getPurchasedProductsByProductId$(PolicyProductIdEnum.Caravan);

        this.validityStatusCodeEnum = PolicyValidityStatusCodeEnum;
    }

    public closeModal(): void {
        this.activeModal.close();
    }
}
